export default {
      id: "oc-remotefile-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-remotefile",
      toString: function () {
        return this.url;
      }
    }